import api from './api';

export interface StripeAccountStatus {
  accountId: string | null;
  status: string | null;
  onboardingCompleted: boolean;
  onboardingUrl: string | null;
  detailsSubmitted: boolean;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
}

export interface SellerInfo {
  id: string;
  email: string;
  name: string | null;
  role: string;
  stripeAccountId: string | null;
  stripeAccountStatus: string | null;
  stripeOnboardingCompleted: boolean;
  businessName: string | null;
  businessType: string | null;
  businessRegistrationNumber: string | null;
  businessAddressLine1: string | null;
  businessAddressLine2: string | null;
  businessCity: string | null;
  businessPostalCode: string | null;
  businessCountry: string | null;
  businessTaxId: string | null;
  bankAccountHolderName: string | null;
  bankAccountSortCode: string | null;
  bankAccountNumber: string | null;
  bankAccountIban: string | null;
  bankAccountBic: string | null;
}

export interface UpdateSellerInfoData {
  businessName?: string;
  businessType?: string;
  businessRegistrationNumber?: string;
  businessAddressLine1?: string;
  businessAddressLine2?: string;
  businessCity?: string;
  businessPostalCode?: string;
  businessCountry?: string;
  businessTaxId?: string;
  bankAccountHolderName?: string;
  bankAccountSortCode?: string;
  bankAccountNumber?: string;
  bankAccountIban?: string;
  bankAccountBic?: string;
}

class SellerOnboardingService {
  async createStripeAccount(): Promise<{ accountId: string; onboardingUrl: string }> {
    const response = await api.post('/sellers/stripe-account');
    return response.data;
  }

  async getStripeAccountStatus(): Promise<StripeAccountStatus> {
    const response = await api.get('/sellers/stripe-account-status');
    return response.data;
  }

  async createOnboardingLink(): Promise<{ url: string }> {
    const response = await api.post('/sellers/onboarding-link');
    return response.data;
  }

  async updateSellerInfo(data: UpdateSellerInfoData): Promise<void> {
    await api.put('/sellers/info', data);
  }

  async getSellerInfo(): Promise<SellerInfo> {
    const response = await api.get('/sellers/info');
    return response.data;
  }

  async linkStripeAccount(stripeAccountId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/sellers/link-stripe-account', { stripeAccountId });
    return response.data;
  }
}

export const sellerOnboardingService = new SellerOnboardingService();



